import { cn } from '@/shared/lib/utils'

interface ContentContainerProps {
  children: React.ReactNode
  className?: string
}

/**
 * Contenedor principal de contenido con scroll siempre visible.
 * Usado en el layout principal para el área de contenido del inset.
 */
export function ContentContainer({ children, className }: ContentContainerProps) {
  return (
    <div
      className={cn(
        "h-full w-full max-w-full rounded-l-xl rounded-r-md border bg-card shadow-sm px-6 pt-3 pb-6 overflow-auto scrollbar-always-visible",
        className
      )}
    >
      <div className="w-full max-w-full min-w-0">
        {children}
      </div>
    </div>
  )
}
